import { FC, HTMLAttributes } from 'react';
import Lottie from 'lottie-react';
import styled from 'styled-components';

const LottieEffectOverlayContainer = styled.div`
    position: fixed;
    inset: 0;
    overflow: hidden;
    pointer-events: none;
    z-index: 9999;
`;

const LottieEffectStage = styled.div`
    position: absolute;
    left: 50%;
    top: 50%;
    width: 1920px;
    height: 1024px;
    transform: translate(-50%, -50%);
`;

export type LottieEffectOverlayProps = HTMLAttributes<HTMLDivElement> & {
    animationData: unknown;
    onComplete: () => void;
};

export const LottieEffectOverlay: FC<LottieEffectOverlayProps> = ({
    animationData,
    onComplete,
    ...props
}) => (
    <LottieEffectOverlayContainer {...props}>
        <LottieEffectStage>
            <Lottie
                animationData={animationData}
                loop={false}
                onComplete={onComplete}
                style={{ width: '100%', height: '100%' }}
            />
        </LottieEffectStage>
    </LottieEffectOverlayContainer>
);
